import * as React from "react";
const SvgPause = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.302.563h-1.64a1.01 1.01 0 0 0-1.01 1.01V16.04c0 .557.452 1.009 1.01 1.009h1.64a1.01 1.01 0 0 0 1.01-1.01V1.573a1.01 1.01 0 0 0-1.01-1.01M13.337.563h-1.64a1.01 1.01 0 0 0-1.01 1.009V16.04c0 .558.452 1.01 1.01 1.01h1.64a1.01 1.01 0 0 0 1.01-1.01V1.572a1.01 1.01 0 0 0-1.01-1.01"
  }
));
export default SvgPause;
